// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-title-hover[data-v-0a6fe16b]{color:var(--v-primary-base);transition:all .2s ease-in-out}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
